import { render } from "./App.vue?vue&type=template&id=8e7365c4&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8e7365c4&scoped=true&lang=css"

import exportComponent from "/Users/faithful/Apps/Kinfolk/kinfolk-growth/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7365c4"]])

export default __exports__